import type { EnvironmentVariablesModel } from "./environment.model";

export enum EndPageEnum {
    ConfirmationPage = "ConfirmationPage",
    ErrorPage = "ErrorPage",
}
export interface CurrentPromo {
    promoImg: string;
    giftAmount: number;
}

export interface GlobalModel {
    showDelayModal: boolean;
    contactComplete: boolean;
    showForm: boolean;
    activeSection: string;
    step: number;
    endPage: null | EndPageEnum;
    currentPromo: CurrentPromo[];
    delay: number;
    tick: ReturnType<typeof setInterval> | null;
    env: EnvironmentVariablesModel;
    incentiveAmount: number;
}
